<template>
  <div>
    <div class="container">
      <!-- Outer Row -->
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-9">
          <div
            class="card o-hidden border-0 shadow-lg my-5"
            style="background-color: #cacaca86"
          >
            <div class="card-body p-0">
              <!-- Nested Row within Card Body -->

              <div class="row">
                <div
                  class="col-lg-6 d-none d-md-block"
                  style="border-right: 1px solid #f4f4f4"
                >
                  <!--<div class="bg-login-image"></div>-->
                  <div class="d-flex justify-content-center">
                    <img
                      :src="data.image"
                      alt="Logo MyCourse"
                      style="width: 50%"
                    />
                  </div>
                  <p
                    style="
                      letter-spacing: 1px;
                      font-size: 120%;
                      text-align: center;
                      margin-top: 30px;
                    "
                  >
                    {{ data.description }}
                  </p>
                </div>

                <div class="col-lg-6">
                  <div class="p-5">
                    <div class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">{{ data.title }}</h1>
                      <p style="letter-spacing: 1px">{{ data.subtitle }}</p>
                    </div>
                    <div class="alert alert-danger" v-if="error">
                      {{ error }}
                    </div>
                    <AlertComponent
                      :message="successMessage"
                      :alert-type="'success'"
                    />
                    <form @submit.prevent="login_request">
                      <br />
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control form-control-user"
                          id="exampleInputEmail"
                          autocomplete="email"
                          placeholder="Indirizzo email"
                          v-model="loginrequest.email"
                          autofocus
                        />
                      </div>
                      <div class="alert alert-danger" v-if="errors.email">
                        {{ errors.email[0] }}
                      </div>
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control form-control-user"
                          autocomplete="current-password"
                          id="exampleInputPassword"
                          v-model="loginrequest.password"
                          placeholder="Password"
                        />
                        <div class="alert alert-danger" v-if="errors.password">
                          {{ errors.password[0] }}
                        </div>
                      </div>
                      <br />
                      <button
                        type="submit"
                        class="btn btn-primary btn-user btn-block w-100"
                      >
                        Login
                      </button>
                    </form>
                    <hr />
                    <div class="text-center">
                      <router-link to="/password-recovery" class="small"
                        >Non ricordi la password?</router-link
                      >
                    </div>
                    <div class="text-center">
                      <router-link class="small" to="/register"
                        >Non hai un account? Clicca qui!</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/services/http.js";
import AlertComponent from "@/components/AlertComponent.vue";
import { useAuth } from "@/stores/auth.js";
import router from "@/router";
export default {
  name: "LoginPage",
  components: { AlertComponent },
  props: {},
  /*setup() {
    const router = 
  },*/
  data() {
    return {
      data: [],
      request: {
        website: "https://vascularclass.it/",
        slug: "login",
      },
      error: "",
      errors: [],
      loginrequest: {
        email: "",
        password: "",
      },
      user: "",
      successMessage: "",
    };
  },
  mounted() {
    this.successMessage = localStorage.getItem("successMessageReset");
    localStorage.removeItem("successMessageReset");
    this.getImage();
    const auth = useAuth();
    if (auth.token) {
      router.push("/dashboard");
    }
  },
  methods: {
    login_request() {
      http
        .post("/login", this.loginrequest)
        .then((response) => {
          console.log(response.data);
          const auth = useAuth();
          auth.setToken(response.data.token);
          auth.setUser(response.data.user);
          location.reload();

          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          this.loginrequest.password = "";
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          } else {
            this.error = error.response.data.message;
            return;
          }
        });
    },
    getImage() {
      const data = {
        slug: "login",
      };
      http
        .post("/dinamic-page", data)
        .then((response) => {
          this.data = response.data.data.content[0];
        })
        .catch(function (error) {
          console.log("errore resposnse" + error);
        });
    },
  },
};
</script>